// extracted by mini-css-extract-plugin
export default {"logoContainer":"Logo_logoContainer__jjIJW","p1Text":"Logo_p1Text__k4zZn","p2Text":"Logo_p2Text__NqgVt"};